import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.img`
  display: block;
  z-index: 3;
  width: auto;
  height: 260px;
  margin: 0 auto -80px auto;
  position: relative;

  ${media.moreThan('sm')`
    margin-bottom: -60px;
  `};

  ${media.moreThan('smPlus')`
    position: absolute;
    bottom: 0;
    right: 0;
    height: 370px;
  `};

  ${media.moreThan('lg')`
    height: 480px;
  `};
`;
